import React from 'react';

import './suggestion-view.scss';

const SuggestionView: React.FC<{ suggestion: any; }> = ({ suggestion }) => {
    if (suggestion.category_name === 'producer_suggestion' || suggestion.category_name === 'dealer_suggestion') {
        return (
            <a href={suggestion.url} className="react-autosuggest__suggestion__view react-autosuggest__suggestion__view--link">
                {suggestion.imgUrl && <img src={suggestion.imgUrl} alt={suggestion.altAttr}/>}
                <div dangerouslySetInnerHTML={{ __html: `${suggestion.hl_phrase}` }}/>
            </a>
        );
    }

    return (
        <div
            className="react-autosuggest__suggestion__view"
            dangerouslySetInnerHTML={{ __html: `${suggestion.hl_phrase} <span class="react-autosuggest__suggestion__view--gray">w kategorii ${suggestion.category_name}</span>` }}
        />
    );
};

export default SuggestionView;
